import React from "react";
import { useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const routeTitles = {
  "/": "Inicio",
  "/appointment-schedule": "Administración de Citas",
  "/appointment-internal": "Citas Médicas",
  "/appointment-internal/edit": "Modificar Cita",
  "/appointment-internal/start": "Inicio Consulta",
  "/appointment-histories": "Historia Clínica",
  "/electronic-recipes": "Recetas Digitales",
  "/centers": "Consultorios Médicos",
  "/centers/edit": "Modificar",
  "/centers/create": "Agregar",
  "/appointment-admin": "Administración de Citas",
  "/medical-parameters": "Parámetros Médicos",
  "/medical-parameters/edit": "Modificar",
  "/medical-parameters/create": "Agregar",
  "/medical-services": "Mis Servicios",
  "/payment-methods": "Mis Métodos de Pago",
  "/purchasing-prescriptions": "Compras de Recetarios",
  "/monthly-closing": "Cierres Mensuales",
  "/monthly-closing/open-months": "Detalle Cierre Mensual",
  "/monthly-closing/close-months": "Detalle Cierre Mensual",
  "/medical-specialities": "Especialidades Médicas",
};

// `titles` agrega nombres de rutas propios del layout (por ejemplo, farmacia).
const DynamicBreadcrumb = ({ actions, titles }) => {
  const location = useLocation();
  const pathnames = location.pathname
    .split("/")
    .filter((x) => x && !x.startsWith(":")); // Filtra parámetros dinámicos

  const filteredPathnames = pathnames.filter((segment) => isNaN(segment));

  return (
    <Breadcrumb className="border-top" listTag="div">
      <BreadcrumbItem href="/" tag="a">
        {routeTitles["/"]}
      </BreadcrumbItem>

      {/* Generate Breadcrumb Items */}
      {filteredPathnames.map((value, index) => {
        const to = `/${filteredPathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === filteredPathnames.length - 1;

        // Obtiene el título de la ruta o usa el valor capitalizado
        const title =
          titles?.[to] ||
          routeTitles[to] ||
          value.charAt(0).toUpperCase() + value.slice(1);

        // Si es el último segmento, renderízalo como texto (disabled)
        return isLast ? (
          <BreadcrumbItem key={to} active tag="span">
            {title}
          </BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={to} href={to} tag="a">
            {title}
          </BreadcrumbItem>
        );
      })}

      {/* Contenido opcional alineado a la derecha de la barra (p. ej. indicadores). */}
      {actions && <div className="dhn-breadcrumb__actions">{actions}</div>}
    </Breadcrumb>
  );
};

export default DynamicBreadcrumb;
